import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import Button from "components/button"
import { SwitchButton } from "components/switchButton"
import { TooltipParagraph } from "components/tooltipParagraph";
import { IOrgRole } from "interfaces"
import moment from "moment";
import { Link } from "react-router-dom"
import { isHaveActionPermission } from "utills/helpers";

interface OrgRoleTableProps {
  data?: IOrgRole[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const RoleTable = ({data = [], pageSize = 10, currentPage = 1, _toggleActive }: OrgRoleTableProps) => {
  return (
    <div className="flow-root">
      <div className="overflow-x-auto">
        <div className="relative inline-block min-w-full align-middle">
          <table className="min-w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
                >
                  No
                </th>
                <th scope="col" className="th">
                  Role Name
                </th>
                <th scope="col" className="th">
                  Org Name
                </th>
                <th scope="col" className="th">
                  Created At
                </th>
                <th scope="col" className="th">
                  Created By
                </th>
                <th scope="col" className="th">
                  Updated at
                </th>
                <th scope="col" className="th">
                  Role status
                </th>
                <th scope="col" className="th">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {data.map((role: IOrgRole, index: number) => (
                <tr key={index}>
                  <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                    {(currentPage - 1) * pageSize + 1 + index}
                  </td>
                  <td className="td">{role.name}</td>
                  <td className="td max-w-40">
                    <TooltipParagraph 
                      text={role.organization_name}
                      className="whitespace-pre-wrap max-w-[280px]"
                    />
                  </td>
                  <td className="td">{moment(role.created).format("DD/MM/YYYY HH:mm:ss")}</td>
                  <td className="td">{role.created_by}</td>
                  <td className="td">{moment(role.updated).format("DD/MM/YYYY HH:mm:ss")}</td>
                  <td className="td">
                    <SwitchButton
                      checked={role.is_active}
                      disabled={
                        !isHaveActionPermission(
                          "role_management",
                          "organization",
                          "edit"
                        )
                      }
                      onChange={() => _toggleActive(role.id, role.is_active)}
                    />
                  </td>
                  <td className="td flex justify-end items-end gap-x-2 py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                    <Link to={`/organization/roles/${role.id}`} target="_blank" className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission(
                      "role_management",
                      "organization",
                      "edit"
                    ) ? (
                      <Link
                        to={`/organization/roles/${role.id}/edit`}
                        target="_blank"
                        className="w-fit"
                      >
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

  )
}